export let MAIN_ITEM_TYPE_VALUES;
(function (MAIN_ITEM_TYPE_VALUES) {
  MAIN_ITEM_TYPE_VALUES[MAIN_ITEM_TYPE_VALUES["FEATURED_VIDEO"] = 1] = "FEATURED_VIDEO";
  MAIN_ITEM_TYPE_VALUES[MAIN_ITEM_TYPE_VALUES["CHANNEL_COVER"] = 2] = "CHANNEL_COVER";
})(MAIN_ITEM_TYPE_VALUES || (MAIN_ITEM_TYPE_VALUES = {}));
//# sourceMappingURL=main-item-type-values.js.map